// extracted by mini-css-extract-plugin
export var alt = "ParagraphHelloRewardsBanner-module--alt--274ce";
export var container = "ParagraphHelloRewardsBanner-module--container--b0670";
export var desktopOnly = "ParagraphHelloRewardsBanner-module--desktopOnly--239c3";
export var main = "ParagraphHelloRewardsBanner-module--main--b1bb8";
export var mobileOnly = "ParagraphHelloRewardsBanner-module--mobileOnly--1ca21";
export var textLeft = "ParagraphHelloRewardsBanner-module--textLeft--2593e";
export var visuallyHidden = "ParagraphHelloRewardsBanner-module--visuallyHidden--f1038";